import {Product, ProductMediaSources} from "../model/types";
import {getWebpPath} from "@/shared/lib/image/getWebpPath";

export const getProductMedia = (product: Product): string[] => {
    if (!product.img_card) return [];

    return product.img_card.split(";").map(url => getWebpPath(url));
};

export const getProductMediaSources = (imgDetail: string | null): ProductMediaSources[] => {
    if (!imgDetail) return [];

    return imgDetail
        .split(';')
        .filter(Boolean)
        .map((src): ProductMediaSources => ({
            src,
            type: /\.(mp4|webm|ogg)$/i.test(src) ? "video" : "image",
        }));
};
